import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "long-arrow-down-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.5304 22.2813C12.2375 22.5742 11.7626 22.5742 11.4697 22.2813L6.46869 17.2803C6.1758 16.9874 6.1758 16.5125 6.46869 16.2196C6.76159 15.9268 7.23646 15.9268 7.52935 16.2196L11.25 19.9403V0.749969C11.25 0.335756 11.5858 -3.05176e-05 12 -3.05176e-05C12.4142 -3.05176e-05 12.75 0.335756 12.75 0.749969V19.9403L16.4707 16.2196C16.7636 15.9268 17.2385 15.9268 17.5314 16.2196C17.8242 16.5125 17.8242 16.9874 17.5314 17.2803L12.5304 22.2813Z" }, null, -1)
  ])))
}
export default { render: render }